import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { scrollTopChange } from 'src/app/utilities/utilities.file';
import { HostListener } from '@angular/core';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { QdeService } from "src/app/services/qde.service";
import { DataCapture } from 'src/app/model/data-capture';
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { IwService } from 'src/app/services/iw.service';
import { CompleteApplicationData } from 'src/app/model/complete-application';
import { MatSliderChange, MatSlider } from '@angular/material/slider';
import { MatVerticalStepper } from '@angular/material/stepper';
import { ISTATACARD, GENERIC_ERROR, VALIDATION_MSG, IS_CAMPAIGN, TOOLTIPS } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
declare var AmoScript: Function;
declare var form_next_click: Function;
declare var _satellite: any;
declare var analytics: any;

@Component({
  selector: 'app-professional-details',
  templateUrl: './professional-details.component.html',
  styleUrls: ['./professional-details.component.scss']
})
export class ProfessionalDetailsComponent implements OnInit {
  professionalCompleteForm: FormGroup;
  professionalCompleteForm1: FormGroup;
  professionalCompleteForm2: FormGroup;
  elementPosition: any;
  qdeData: any;
  professionalDetails = new DataCapture();
  @ViewChild('matProfessionalBlock') professionalBlock: ElementRef;
  @ViewChild("stepper") stepper: MatVerticalStepper;
  eapplyFormPostQDELabel: any;
  savePersonalData: any;
  caData: any;
  pinList = [];
  filterPin: any[];
  providedPin: any;
  city: any;
  state: any;
  pinNotFound: boolean;
  @Output() professionalDetailsSectionValid = new EventEmitter<any>();
  @Output() professionalDetailsSectionCompleted = new EventEmitter<any>();
  @Input() expanded: any;
  expandProfessional: boolean;
  @Input() masterData: any;
  @Input() step: any = 0;
  //   @HostListener('document:keydown.tab', ['$event'])
  // onKeydownHandler(event: KeyboardEvent) {
  //     event.preventDefault();
  // }
  openStep: any;
  additionalFormVisible: any;
  percentageEmp: any = "100%";
  percentageAnI: any = "0%";
  percentageOfc: any = "0%";
  TATACARD = ISTATACARD;
  employmentDetailsStep: boolean;
  officeAddressStep: boolean;
  annualIncomeStep: boolean;
  empNextClicked: boolean;
  errorEmp: string;
  successEmp: boolean;
  successOfc: boolean;
  errorOfc: string;
  errorAni: string;
  validationMsgs: any;
  airIndiaCardList = ['AISU', 'AIPU', 'EGPU', 'EGSU'];
  showAirIndiaField = false;
  add1Optional: string;
  add2Optional: string;
  pinOptional: string;
  requireFields = true;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  qdeOccupationTypeValue: any;
  qdeChannelTypeValue: any;
  trackOccupationTypeValue: any;
  trackChannelTypeValue: any;
  retrieveOccupationTypeValue: any;
  retrieveChannelTypeValue: any;
  newOccupationDropdown: boolean = false;
  occupations: any;
  placeholder: boolean = false;
  tooltips: any;
  eapplyFormLabel: any;
  fromSWIFTJourney: boolean;
  successAni: boolean = false;
  aiNextClicked: boolean = false;


  constructor(
    private fb: FormBuilder,
    private sharedData: SharedServiceService,
    private completeApp: CompleteApplicationService,
    private iw: IwService,
    private themeService: ThemeService,
    private qdeService: QdeService
  ) {
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.fromSWIFTJourney = this.sharedData.fromSwiftJourney;
    this.validationMsgs = VALIDATION_MSG;
    this.tooltips = TOOLTIPS;
    this.createForm();
    this.createForm1();
    this.createForm2();
    this.ofcAddressNonMandatory();
    this.savePersonalData = this.sharedData.cApersonalData;

    this.occupations = this.iw.getDCoccupationDropdown();
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.qdeData = this.sharedData.qdeSubmitData;
    console.log("qdeData is ==>", this.qdeData);

    //this.qdeOccupationTypeValue = this.qdeData.WSCallUserOccupationCode;
    // this.qdeOccupationTypeValue = this.qdeService.professionalData.WSCallUserOccupationCode;
    this.qdeOccupationTypeValue = this.sharedData.occuVal;
    console.log("occupation type value ==>", this.qdeOccupationTypeValue);
    //this.qdeChannelTypeValue = this.qdeData.WSCallChannelCode;
    this.qdeChannelTypeValue = this.sharedData.channelVal;
    console.log("channel type value ==>", this.qdeChannelTypeValue);



    console.log('this.sharedData.trackApplicationResponse=' + this.sharedData.trackApplicationResponse);
    // console.log('this.sharedData.trackApplicationResponse.eapplyEmploymentDetails=' + this.sharedData.trackApplicationResponse.eapplyEmploymentDetails);
    console.log('this.sharedData.retrievedApplicationResponse=' + this.sharedData.retrievedApplicationResponse);


    if (this.sharedData.trackApplicationResponse && this.sharedData.trackApplicationResponse != undefined) {
      if(this.fromSWIFTJourney){
        this.trackOccupationTypeValue = this.sharedData.trackApplicationResponse.data.employmentDetails.occupationType;
      }
      else{
        this.trackOccupationTypeValue = this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType;
      }
      console.log("trackOccupationTypeValue =>", this.trackOccupationTypeValue);
      this.trackChannelTypeValue = this.sharedData.trackApplicationResponse.channelCode;
      console.log("trackChannelTypeValue =>", this.trackChannelTypeValue);
    }

    if (this.sharedData.retrievedApplicationResponse && this.sharedData.retrievedApplicationResponse != undefined) {
      this.retrieveOccupationTypeValue = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode;
      console.log("retrieveOccupationTypeValue  ==>", this.retrieveOccupationTypeValue);
      this.retrieveChannelTypeValue = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode;
      console.log("retrieveChannelTypeValue ==>", this.retrieveChannelTypeValue);
    }

    if (this.qdeOccupationTypeValue == "E" && this.qdeChannelTypeValue == "EAPL"
      || this.trackOccupationTypeValue == "E" && this.trackChannelTypeValue == "EAPL"
      || this.retrieveOccupationTypeValue == "E" && this.retrieveChannelTypeValue == "EAPL") {
      this.newOccupationDropdown = true;
      console.log("Channel code EAPL selected");
    }else if (this.qdeOccupationTypeValue == "E" && this.qdeChannelTypeValue == "SAPL"
    || this.trackOccupationTypeValue == "E" && this.trackChannelTypeValue == "SAPL"
    || this.retrieveOccupationTypeValue == "E" && this.retrieveChannelTypeValue == "SAPL") {
    this.newOccupationDropdown = true;
    console.log("Channel code SAPL selected");
  }

    this.professionalCompleteForm1.patchValue({
      fcnPin: this.qdeData ? this.qdeData.WSCallUserOfficePincode : ''
    })
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.add1Optional = this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine1_label + '(Optional)';
    this.add2Optional = this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine2_label + '(Optional)';
    this.pinOptional = this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label + '(Optional)';
    this.professionalCompleteForm.valueChanges.subscribe(v => {
      this.savePartialData();
    });
    this.professionalCompleteForm1.valueChanges.subscribe(v => {
      this.savePartialData();
    })
    this.professionalCompleteForm2.valueChanges.subscribe(v => {
      this.savePartialData();
    })
    if (this.savePersonalData) {
      this.completeApp.saveUpdateApplication(this.savePersonalData).subscribe((result: any) => {
      })
    }

    this.f1.fcnPin.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.pinList) {
        this.filterPin = this.pinList.filter(pin => ('' + pin).startsWith(value));
      } else {
        this.filterPin = null;
      }
      this.fetchAutoPin();
    });
    this.expandProfessional = this.completeApp.expandProfessional;
    this.patchDetailsForTracking();
    this.patchDetailsForTracking1();
    // this.savePartialData();
    if(!this.fromSWIFTJourney){
      if (this.airIndiaCardList.includes(this.qdeData ? this.qdeData.WSCallCardType.toUpperCase() : '')) {
        this.showAirIndiaField = true;
      } else {
        this.showAirIndiaField = false;
      }
      if ((this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.ckycStatus.toLowerCase() == 'success') || this.showAirIndiaField || (this.qdeData && this.qdeData.WSCallCardType == 'DCIU')) {
        this.additionalFormVisible = true;
      } else {
        this.additionalFormVisible = false;
      }
    }
    else{
      if (this.airIndiaCardList.includes(this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallCardType.toUpperCase() : '')) {
        this.showAirIndiaField = true;
      } else {
        this.showAirIndiaField = false;
      }
      if ((this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.ckycStatus.toLowerCase() == 'success') || this.showAirIndiaField || (this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallCardType == 'DCIU')) {
        this.additionalFormVisible = true;
      } else {
        this.additionalFormVisible = false;
      }
    }
    
    this.getExpamdedStatus();

  }

  ngOnChanges() {
    let list: any;
    if (this.masterData) {
      console.log('master data', this.masterData);
      console.log('channel', this.sharedData.paramschannel, sessionStorage.getItem('channelId'));
      if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '901') || sessionStorage.getItem('channelId') == '901') {
        list = this.masterData.bancaCityList;
      } else {
        list = this.masterData.cityList;
      }
      list.forEach(pinObj => { this.pinList.push(...pinObj.pin) });
      if (this.pinList) {
        this.pinList = this.pinList.filter((v, i, a) => a.indexOf(v) === i);
      }
    }
    if (this.masterData && this.f1.fcnPin.value) {
      this.providedPin = list.find(
        city => city.pin.includes(this.f1.fcnPin.value) >= 1
      );
      this.city = this.providedPin ? this.providedPin.name : "";
      this.state = this.providedPin ? this.providedPin.state : "";
      this.sharedData.offStdCode = this.providedPin
        ? this.providedPin.std
          ? this.providedPin.std[0]
          : ""
        : "";
      this.sharedData.officeCity = this.city;
      this.sharedData.officeState = this.state;
    }
  }

  createForm() {
    this.professionalCompleteForm = this.fb.group({
      fcnOfcPhone: ['', Validators.compose([Validators.pattern("^([2-9]{1}[0-9]{6,9})$")])],
      fcnBusinessType: ['', []]
    })
  }

  createForm1() {
    this.professionalCompleteForm1 = this.fb.group({
      fcnAddress1: ['', Validators.compose([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")])],
      fcnAddress2: ['', Validators.compose([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")])],
      fcnLandmark: ['', Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")],
      fcnPin: ['', Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]{5}$')])]
    })
  }

  createForm2() {
    this.professionalCompleteForm2 = this.fb.group({
      fcnAnnualIncome: ["", Validators.required]
    })
  }

  myincomevalue(event: MatSliderChange, abcd) {
    this.f2.fcnAnnualIncome.setValue(event.value);
  }

  incomeSlider(mySlidervalue, fcnAnnualIncome) {
    fcnAnnualIncome.value = mySlidervalue;
    if (fcnAnnualIncome.value != 0) {
      fcnAnnualIncome.value <= 200000000 ? this.professionalCompleteForm2.get('fcnAnnualIncome').setErrors(null) : this.professionalCompleteForm2.get('fcnAnnualIncome').setErrors({ 'maxIncome': true });
    }
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.professionalCompleteForm.controls[controlName].hasError(errorName);
  }

  get f() {
    return this.professionalCompleteForm.controls;
  }

  get f1() {
    return this.professionalCompleteForm1.controls;
  }

  get f2() {
    return this.professionalCompleteForm2.controls;
  }

  showLable1() {
    (this.f.fcnBusinessType.value.length) === 0 ? this.placeholder = true : true;
  }
  hideLable1() {
    (this.f.fcnBusinessType.value.length) === 0 ? this.placeholder = true : this.placeholder = false;
  }
  focusOut() {
    this.placeholder = false;
  }

  numberOnlyPhone(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  numberOnlyPin(event) {
    if (this.f1.fcnPin.value.length < 1) {
      let regex1 = /[1-9]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    }
    else {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  scrollTopChangeProfessional() {
    scrollTopChange(this.professionalBlock);
  }

  savePartialData() {
    this.professionalDetails.offPhone = this.f.fcnOfcPhone ? this.f.fcnOfcPhone.value : null;
    this.professionalDetails.businessType = this.f.fcnBusinessType ? this.f.fcnBusinessType.value : null;
    this.professionalDetails.offAddLine1 = this.f1.fcnAddress1 ? this.f1.fcnAddress1.value : null;
    this.professionalDetails.offAddLine2 = this.f1.fcnAddress2 ? this.f1.fcnAddress2.value : null;
    this.professionalDetails.offLandmark = this.f1.fcnLandmark ? this.f1.fcnLandmark.value : null;
    this.professionalDetails.offPincode = this.f1.fcnPin ? this.f1.fcnPin.value : null;
    this.professionalDetails.annualIncome = this.f2.fcnAnnualIncome ? this.f2.fcnAnnualIncome.value : null;
    this.professionalDetails.offCity = this.city ? this.city : null;
    this.completeApp.professionalData = this.professionalDetails;
    if(this.fromSWIFTJourney){
      this.professionalDetailsSectionValid.emit({ 'proValid': this.professionalCompleteForm.valid && this.professionalCompleteForm1.valid && this.professionalCompleteForm2.valid})
    }
    else{
      this.professionalDetailsSectionValid.emit({ 'proValid': this.professionalCompleteForm.valid && this.professionalCompleteForm1.valid })
    }
    

    this.caData = new CompleteApplicationData();
    this.caData.WSCallUserOffPhone = this.f.fcnOfcPhone ? this.f.fcnOfcPhone.value : '';
    this.caData.WSCallBusinessType = this.f.fcnBusinessType ? this.f.fcnBusinessType.value : '';
    this.caData.WSCallUserOffAddLine1 = this.f1.fcnAddress1 ? this.f1.fcnAddress1.value : '';
    this.caData.WSCallUserOffAddLine2 = this.f1.fcnAddress2 ? this.f1.fcnAddress2.value : '';
    this.caData.WSCallUserResiPincode = this.f1.fcnPin ? this.f1.fcnPin.value : '';
    this.caData.WSCallUserOffLandmark = this.f1.fcnLandmark ? this.f1.fcnLandmark.value : '';
    this.caData.WSCallUserAnnualIncomeValue = this.f2.fcnAnnualIncome ? this.f2.fcnAnnualIncome.value : null;
    if(this.fromSWIFTJourney){
      this.caData.WSCallUserApplicationNumber = this.sharedData.trackApplicationResponse.data ? this.sharedData.trackApplicationResponse.data.applicationNumber : (this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '');
    }
    else{
      this.caData.WSCallUserApplicationNumber = this.sharedData.trackApplicationResponse ? this.sharedData.trackApplicationResponse.applicationNumber : (this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '');
    }
    this.sharedData.cAprofessisonalData = this.caData;
    console.log("cAprofessisonalData =====>", this.sharedData.cAprofessisonalData);
    this.setPercentageProfessional();
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  setApplicationData() {

    let reqObj = Object.assign({}, this.sharedData.qdeSubmitData, this.caData, this.sharedData.cAadditionalData, this.sharedData.cApersonalData, this.sharedData.cAadditionalCardFeatureData);
    reqObj = this.trimObject(reqObj);
    console.log("request Body from professional details saveApplication data", reqObj);
    this.completeApp.saveUpdateApplication(reqObj).subscribe((result: any) => {
      if (result && result.DataCaptureRes && result.DataCaptureRes.WSCallStatus && result.DataCaptureRes.WSCallStatus.toLowerCase() === 'success') {
        this.sharedData.dcSeqId = result.DataCaptureRes.WSCallSequenceId;
        if (this.fromSWIFTJourney) {
          console.log("inside fromSWIFTJourney from setApplicationData");
          if (this.empNextClicked == true && this.aiNextClicked == false) {
            console.log("successEmp true from setApplicationData");
            this.successEmp = true;
          }
          else if (this.empNextClicked == true && this.aiNextClicked == true) {
            console.log("successOfc true from setApplicationData");
            this.successOfc = true;
          }
          else if (this.empNextClicked == false) {
            console.log("successAni true from setApplicationData");
            this.successAni = true;
          }
        }
        else {
          this.empNextClicked ? this.successEmp = true : this.successOfc = true;
        }
        if (this.empNextClicked) {
          console.log("Next stepper called from professional details");
          this.employmentDetailscompleted();
          this.stepper.next();
        } else {
          if (this.fromSWIFTJourney) {
            console.log("Inside setApplicationData else block when empNextClicked false from professional component");
            // this.step++;
            // this.sharedData.setAddCardOpenState({expand: true, step:2});
            this.professionalDetailsSectionValid.emit({
              // expanded: true,
              // steps: this.step,
              proValid: this.professionalCompleteForm.valid && this.professionalCompleteForm1.valid && this.professionalCompleteForm2.valid
            });
            this.sharedData.setAddCardOpenState({ expand: true, step: 2 });
            this.employmentDetailscompleted();
          }
          else {
            // this.step++;
            // this.sharedData.setAddCardOpenState({expand: true, step:2});
            this.professionalDetailsSectionValid.emit({
              // expanded: true,
              // steps: this.step,
              proValid: this.professionalCompleteForm.valid && this.professionalCompleteForm1.valid
            });
            this.sharedData.setAddCardOpenState({ expand: true, step: 2 });
            this.employmentDetailscompleted();
          }
        }
      } else {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        if (this.fromSWIFTJourney) {
          if (this.empNextClicked == true && this.aiNextClicked == false) {
            this.successEmp = false;
            this.errorEmp = GENERIC_ERROR;
          }
          else if (this.empNextClicked == true && this.aiNextClicked == true) {
            this.successOfc = false;
            this.errorOfc = GENERIC_ERROR;
          }
          else if (this.empNextClicked == false) {
            this.successAni = false;
            this.errorAni = GENERIC_ERROR;
          }
        }
        else {
          if (this.empNextClicked) {
            this.successEmp = false;
            this.errorEmp = GENERIC_ERROR;
          } else {
            this.successOfc = false;
            this.errorOfc = GENERIC_ERROR;
          }
        }
      }

    }, (error) => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      if (this.fromSWIFTJourney) {
        if (this.empNextClicked == true && this.aiNextClicked == false) {
          this.successEmp = false;
          this.errorEmp = GENERIC_ERROR;
        }
        else if (this.empNextClicked == true && this.aiNextClicked == true) {
          this.successOfc = false;
          this.errorOfc = GENERIC_ERROR;
        }
        else if (this.empNextClicked == false) {
          this.successAni = false;
          this.errorAni = GENERIC_ERROR;
        }
      }
      else {
        if (this.empNextClicked) {
          this.successEmp = false;
          this.errorEmp = GENERIC_ERROR;
        } else {
          this.successOfc = false;
          this.errorOfc = GENERIC_ERROR;
        }
      }
    })
  }

  employmentDetailsNext() {
    this.empNextClicked = true;
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.employmentSection_details && this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label
      }
    }

    form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);
    this.setApplicationData();
    this.employmentDetailscompleted();

    /* Analytics added */
    // if (window['analytics']) {
    //   analytics.track('eapply__click__next__addition_professional_detail', {
    //     'MODE_OF_CONVERSION': '',
    //     'IS_ORGANIC': 'N',
    //     'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
    //     'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
    //     'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
    //     'CHANNEL_NAME': this.sharedData.paramschannel,
    //     'JOURNEY_NAME': 'EAPPLY',
    //     'FIRST_NAME': this.qdeData.WSCallUserFirstName,
    //     'LAST_NAME': this.qdeData.WSCallUserLastName,
    //     'MIDDLE_NAME': this.qdeData.WSCallUserMiddleName,
    //     'EMAIL': this.qdeData.WSCallUserEmailId,
    //     'MOBILE_NO': this.qdeData.WSCallUserMobileNumber,
    //     'PAN': this.qdeData.WSCallUserPanNumber,
    //     'DOB': this.qdeData.WSCallUserDOB,
    //     'CITY': this.qdeData.WSCallUserCity,
    //     'CARD_TYPE': this.sharedData.sbic_card_Type,
    //     'office_phone_num': this.f.fcnOfcPhone.value
    //   })
    // }

  }

  employmentDetailscompleted() {
    this.employmentDetailsStep = this.percentageEmp === '100%' ? true : false;
    this.officeAddressStep = this.percentageOfc === '100%' ? true : false;
    this.annualIncomeStep = this.percentageAnI === '100%' ? true : false;
  }

  fetchAutoPin() {
    if (this.f1.fcnPin.value && this.f1.fcnPin.value.length == 6 && this.masterData) {
      let cityList: any;
      console.log('professional channel', this.sharedData.paramschannel);
      if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '901') || sessionStorage.getItem('channelId') == '901') {
        cityList = this.masterData.bancaCityList;
      } else {
        cityList = this.masterData.cityList;
      }
      this.providedPin = cityList.find(
        city => city.pin.includes(this.f1.fcnPin.value) >= 1
      );
      this.city = this.providedPin ? this.providedPin.name : "";
      this.state = this.providedPin ? this.providedPin.state : "";
      this.sharedData.officeCity = this.city;
      this.sharedData.offStdCode = this.providedPin
        ? this.providedPin.std
          ? this.providedPin.std[0]
          : ""
        : "";
    } else {
      this.providedPin = null;
      this.city = "";
      this.sharedData.officeCity = null;
      this.sharedData.offStdCode = null;
      this.state = "";
    }
    this.providedPin ? this.professionalCompleteForm1.get('fcnPin').setErrors(null) : this.professionalCompleteForm1.get('fcnPin').setErrors({ 'pinNotFound': true });
    this.setPercentageProfessional();
  }

  setPercentageProfessional() {
    if (this.stepper.selectedIndex === 0) {
      let phonePercent = this.f.fcnOfcPhone.valid ? 1 : 0;
      let totalPercent = phonePercent;
      totalPercent === 0 ? this.percentageEmp = "0%" : true;
      totalPercent === 1 ? this.percentageEmp = "100%" : true;
      console.log(totalPercent);
    } else if (this.stepper.selectedIndex === 1) {
      let add1Percent = this.f1.fcnAddress1.valid ? 1 : 0;
      let add2Percent = this.f1.fcnAddress2.valid ? 1 : 0;
      if(this.fromSWIFTJourney){
        let pinPercent = this.f1.fcnPin.valid ? 1 : 0;
        let totalPercent = add1Percent + add2Percent + pinPercent;
        totalPercent === 0 ? this.percentageOfc = "0%" : true;
        totalPercent === 1 ? this.percentageOfc = "33.33%" : true;
        totalPercent === 2 ? this.percentageOfc = "66.67%" : true;
        totalPercent === 3 ? this.percentageOfc = "100%" : true;
        console.log("totalPercent from professional ==>",totalPercent);
      }
      else{
        if (((this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "P" || this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "T")) || (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "P" || this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "T"))) {
          let pinPercent = 1;
          let totalPercent = add1Percent + add2Percent + pinPercent;
          totalPercent === 0 ? this.percentageOfc = "0%" : true;
          totalPercent === 1 ? this.percentageOfc = "33.33%" : true;
          totalPercent === 2 ? this.percentageOfc = "66.67%" : true;
          totalPercent === 3 ? this.percentageOfc = "100%" : true;
        }
        else {
          let pinPercent = this.f1.fcnPin.valid ? 1 : 0;
          let totalPercent = add1Percent + add2Percent + pinPercent;
          totalPercent === 0 ? this.percentageOfc = "0%" : true;
          totalPercent === 1 ? this.percentageOfc = "33.33%" : true;
          totalPercent === 2 ? this.percentageOfc = "66.67%" : true;
          totalPercent === 3 ? this.percentageOfc = "100%" : true;
        }
      }
      
    }
    else if (this.stepper.selectedIndex === 2) {
      let incomePercent = this.f2.fcnAnnualIncome.valid ? 1 : 0;
      let totalPercent = incomePercent;
      totalPercent === 0 ? this.percentageAnI = "0%" : true;
      totalPercent === 1 ? this.percentageAnI = "100%" : true;
      console.log(totalPercent);
    }
  }

  patchDetailsForTracking() {
    if (this.sharedData.trackApplicationResponse) {
      if (this.fromSWIFTJourney) {
        console.log("trying to autoopopulate from patchDetailsForTracking in professional  details");
        this.city = this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offCity ? this.sharedData.trackApplicationResponse.data.officeAddress.offCity : ''
        this.state = this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offState ? this.sharedData.trackApplicationResponse.data.officeAddress.offState : ''
        this.professionalCompleteForm.patchValue({
          fcnOfcPhone: this.sharedData.trackApplicationResponse && this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offPhone ? this.sharedData.trackApplicationResponse.data.officeAddress.offPhone : '',
          // fcnBusinessType: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallBusinessType ? this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallBusinessType : '',
          fcnBusinessType: ""
        })
      }
      else {
        console.log("trying to autopopulate else from patchDetailsForTracking in professional  details");
        this.city = this.sharedData.trackApplicationResponse.officeAddress.offCity ? this.sharedData.trackApplicationResponse.officeAddress.offCity : ''
        this.state = this.sharedData.trackApplicationResponse.officeAddress.offState ? this.sharedData.trackApplicationResponse.officeAddress.offState : ''
        this.professionalCompleteForm.patchValue({
          fcnOfcPhone: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffPhone ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffPhone : '',
          fcnBusinessType: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallBusinessType ? this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallBusinessType : '',
        })
      }

    }
  }

  patchDetailsForTracking1() {
    if (this.sharedData.trackApplicationResponse) {
      if(this.fromSWIFTJourney){
        console.log("trying to autoopopulate from patchDetailsForTracking1 in professional  details");
        this.professionalCompleteForm1.patchValue({
          fcnAddress1: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine1 ? this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine1 : '',
          fcnAddress2: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine2 ? this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine2 : '',
          fcnLandmark: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine3 ? this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine3 : '',
          fcnPin: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress ? this.sharedData.trackApplicationResponse.data.officeAddress.offPinCode :
            (this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress ? this.sharedData.trackApplicationResponse.data.officeAddress.offPinCode : ''),
        });
        if(this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.officeAddress) {
          if ((this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine1 && this.sharedData.trackApplicationResponse.data.officeAddress.offAddressLine2 && this.sharedData.trackApplicationResponse.data.officeAddress.offPinCode) && !(this.f1.fcnAddress1.dirty && this.f1.fcnAddress2.dirty && this.f1.fcnPin.dirty)) {
            this.percentageOfc = "100%";
            this.employmentDetailscompleted();
          }
        }
      }
      else{
        console.log("trying to autopopulate else from patchDetailsForTracking1 in professional  details");
        this.professionalCompleteForm1.patchValue({
          fcnAddress1: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffAddLine1 ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffAddLine1 : '',
          fcnAddress2: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffAddLine2 ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffAddLine2 : '',
          fcnLandmark: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffLandmark ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOffLandmark : '',
          fcnPin: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOfficePincode ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserOfficePincode :
            (this.sharedData.trackApplicationResponse.officeAddress && this.sharedData.trackApplicationResponse.officeAddress.offPinCode ? this.sharedData.trackApplicationResponse.officeAddress.offPinCode : ''),
        })
      }
      
      this.fetchAutoPin();
    }
  }

  stepChanged(event, stepper) {
    stepper.selected.interacted = false;
  }

  additionalExpand() {
    console.log("additionalExpand called from professional details");
    if(this.fromSWIFTJourney){
      this.empNextClicked = true;
    }
    else {
      this.empNextClicked = false;
    }
    this.aiNextClicked = true;
    this.setApplicationData();
    this.employmentDetailscompleted();
    this.callAmoAndLaunch();

    /* Analytics added */
    // if (window['analytics']) {
    //   analytics.track('eapply__click__next__office_address', {
    //     'JOURNEY_NAME': 'EAPPLY',
    //     'IS_ORGANIC': 'N',
    //     'CARD_TYPE': this.sharedData.sbic_card_Type,
    //     'office_addr_line1': this.f1.fcnAddress1.value,
    //     'office_addr_line2': this.f1.fcnAddress2.value,
    //     'office_landmark': this.f1.fcnLandmark.value,
    //     'office_pin_code': this.f1.fcnPin.value,
    //     'FIRST_NAME': this.qdeData.WSCallUserFirstName,
    //     'LAST_NAME': this.qdeData.WSCallUserLastName,
    //     'MIDDLE_NAME': this.qdeData.WSCallUserMiddleName,
    //     'EMAIL': this.qdeData.WSCallUserEmailId,
    //     'MOBILE_NO': this.qdeData.WSCallUserMobileNumber,
    //     'PAN': this.qdeData.WSCallUserPanNumber,
    //     'DOB': this.qdeData.WSCallUserDOB,
    //   })
    // }

  }

  additionalExpand2() {
    this.empNextClicked = false;
    this.setApplicationData();
  }

  // setStep() {
  //   this.step = 0;
  // this.professionalDetailsSectionValid.emit({
  //   expanded: true,
  //   steps: this.step
  // })
  // }


  ofcAddressNonMandatory() {
    if(this.fromSWIFTJourney){
      if ((this.sharedData.qdeSubmitData && (this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "P" || this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "T")) || (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.data.employmentDetails.occupationType == "P" || this.sharedData.trackApplicationResponse.data.employmentDetails.occupationType == "T"))) {
        this.requireFields = false;
        this.professionalCompleteForm1.get('fcnAddress1').setValidators(null);
        this.professionalCompleteForm1.get('fcnAddress1').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnAddress2').setValidators(null);
        this.professionalCompleteForm1.get('fcnAddress2').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnPin').setValidators(null);
        this.professionalCompleteForm1.get('fcnPin').updateValueAndValidity();
      } else {
        this.requireFields = true;
        this.professionalCompleteForm1.get('fcnAddress1').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
        this.professionalCompleteForm1.get('fcnAddress1').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnAddress2').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
        this.professionalCompleteForm1.get('fcnAddress2').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnPin').setValidators(Validators.required);
        this.professionalCompleteForm1.get('fcnPin').updateValueAndValidity();
      }
    }
    else{
      if ((this.sharedData.qdeSubmitData && (this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "P" || this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "T")) || (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "P" || this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "T"))) {
        this.requireFields = false;
        this.professionalCompleteForm1.get('fcnAddress1').setValidators(null);
        this.professionalCompleteForm1.get('fcnAddress1').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnAddress2').setValidators(null);
        this.professionalCompleteForm1.get('fcnAddress2').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnPin').setValidators(null);
        this.professionalCompleteForm1.get('fcnPin').updateValueAndValidity();
      } else {
        this.requireFields = true;
        this.professionalCompleteForm1.get('fcnAddress1').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
        this.professionalCompleteForm1.get('fcnAddress1').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnAddress2').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
        this.professionalCompleteForm1.get('fcnAddress2').updateValueAndValidity();
        this.professionalCompleteForm1.get('fcnPin').setValidators(Validators.required);
        this.professionalCompleteForm1.get('fcnPin').updateValueAndValidity();
      }
    }
    
  }

  callAmoAndLaunch() {
    if (IS_CAMPAIGN) {
      window["page"] = 'ev_dc2';
      window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
      AmoScript();
    }
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.employmentSection_details && this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine1_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine1_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine2_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine2_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine3_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine3_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label
      }
    }

    form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);
  }

  getExpamdedStatus() {
    this.sharedData.openProDetailsObservable.subscribe((status: any) => {
      this.openStep = status.step
      console.log("getExpandedStatus called ==> ", this.openStep)
    })
  }
}

